Ext.define('SA.view.filter.FiltersWindow', {
    alias: 'widget.filters-window',
    extend: 'SA.view.ArrowMenu',

    alignment: 'bottom',
    behaveAsWindow: true,
    closeAction: 'hide',
    cls: 'sa-filters',
    showVisibilityRadioGroup: true,
    height: 670,
    width: 868,

    layout: {
        align: 'stretch',
        type: 'vbox'
    },

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-filters-header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-filters-step',
                    width: 317,

                    html: [
                        '<svg>',
                            '<use href="#sa-icon-step-1"></use>',
                        '</svg>',
                        '<div>Select a data variable</div>'
                    ]
                }, {
                    xtype: 'component',
                    cls: 'sa-filters-step sa-filters-step-2',

                    html: [
                        '<svg>',
                            '<use href="#sa-icon-step-2"></use>',
                        '</svg>',
                        '<div>Build your filter using one to four conditions</div>'
                    ]
                }, {
                    xtype: 'close-button',
                    closeAction: 'close'
                }
            ]
        }, {
            xtype: 'container',
            flex: 1,

            layout: {
                type: 'hbox',
                align: 'stretch'
            },

            items: [
                {
                    xtype: 'simple-container',
                    cls: 'sa-filters-left-ct',

                    items: [
                        {
                            xtype: 'sa-text-field',
                            clearButton: true,
                            cls: 'sa-filters-search-field-input',
                            emptyText: 'Filter',
                            icon: true,
                            itemId: 'filterText',
                            ui: 'compact'
                        }, {
                            xtype: 'component',
                            itemId: 'dataList',

                            tpl: [
                                '<tpl for=".">',
                                    '<div data-attribute="{attribute:htmlEncode}" class="sa-filters-attribute-list-item">{innerHtml}</div>',
                                '</tpl>'
                            ]
                        }
                    ]
                }, {
                    xtype: 'container',
                    cls: 'sa-filters-right-ct',
                    flex: 3,
                    padding: 0,

                    items: [
                        {
                            xtype: 'simple-container',
                            cls: 'sa-filters-visibility-options',

                            items: [
                                {
                                    xtype: 'component',
                                    cls: 'sa-filters-visibility-label',
                                    html: 'Filter:'
                                }, {
                                    xtype: 'sa-toggle-switch',
                                    itemId: 'visibilityToggle',
                                    leftText: 'Off',
                                    rightText: 'On'
                                }, {
                                    xtype: 'sa-radio-group',
                                    cls: 'sa-filters-visibility-radio-group',
                                    ariaLabel: 'Filter display style',
                                    direction: 'row',
                                    itemId: 'visibilityRadioGroup',

                                    items: [
                                        {
                                            boxLabel: 'Hide',
                                            value: 'hide'
                                        }, {
                                            boxLabel: 'Strikeout',
                                            value: 'strikeout'
                                        }
                                    ]
                                }
                            ]
                        }, {
                            xtype: 'container',
                            autoScroll: true,
                            flex: 1,
                            itemId: 'conditions',
                            padding: '0 18 18',

                            layout: {
                                align: 'stretch',
                                type: 'vbox'
                            },

                            plugins: [{
                                ptype: 'sa-animation',
                                duration: 250
                            }]
                        }
                    ],

                    layout: {
                        align: 'stretch',
                        type: 'vbox'
                    }
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-filters-footer',

            items: [
                {
                    xtype: 'sa-button',
                    disabled: true,
                    itemId: 'applyBtn',
                    text: 'Apply',
                    ui: 'primary',
                    width: 118,

                    handler() {
                        this.up('filters-window').save();
                    }
                }, {
                    xtype: 'sa-button',
                    text: 'Close',
                    width: 118,

                    handler() {
                        this.up('filters-window').close();
                    }
                }
            ]
        }
    ],

    listeners: {
        beforehide() {
            this.clearConditionsList();

            this.syncStateWithProjectView();
        }
    },

    initComponent() {
        var filterText;

        this.callParent();

        this.conditionsList = this.down('#conditions');
        this.dataList = this.down('#dataList');
        this.filterText = filterText = this.down('#filterText');
        this.applyBtn = this.down('#applyBtn');

        this.visibilityToggle = this.down('#visibilityToggle');
        this.visibilityRadioGroup = this.down('#visibilityRadioGroup');

        if (!this.showVisibilityRadioGroup) {
            this.visibilityRadioGroup.hide();
        }

        filterText.on({
            buffer: 250,
            scope: this,
            change: this.refreshAttributes
        });

        this.syncStateWithProjectView();

        this.refreshHeight();
    },

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-filters-attribute-list-item',

            click: (ev, target) => {
                if (this.filterQuery.length < 4) {
                    this.filterQuery.push(['>', target.getAttribute('data-attribute'), 0]);

                    this.onControlChange();
                }
            }
        });

        this.visibilityToggle.on('change', (toggle, checked) => {
            var visibility = checked ? 'strikeout' : 'disable';

            if (this.visibility !== visibility) {
                this.visibility = visibility;

                this.onControlChange();
            }
        });

        this.visibilityRadioGroup.on('change', (group, value) => {
            if (value && this.visibility !== value) {
                this.visibility = value;

                this.onControlChange();
            }
        });

        this.mon(SA.Viewport, 'resize', this.refreshHeight, this);
    },

    beforeDestroy() {
        this.callParent();

        this.mun(SA.Viewport, 'resize', this.refreshHeight, this);
    },

    beforeShow() {
        this.callParent();

        this.refresh();
    },

    clearConditionsList() {
        this.conditionsList.query('> *').forEach(ct => {
            ct.destroy();
        });
    },

    onConditionRowChange() {
        var query = [],
            rows = this.conditionsList.query('filter-condition-row');

        rows.forEach(row => {
            if (!row.removed && !row.hideTime) {
                query.push(row.condition);
            }
        });

        this.filterQuery = query;

        this.onConditionsControlChange();
    },

    onConditionRowRemoveRequest(row) {
        var query = this.filterQuery,
            index = query.indexOf(row.condition);

        query.splice(index, 1);

        row.un({
            'change:condition': this.onConditionRowChange,
            'remove:condition': this.onConditionRowRemoveRequest,
            scope: this
        });

        this.onControlChange();
    },

    onConditionsControlChange() {
        this.changed = true;
        this.applyBtn.setDisabled(false);

        this.refreshConditions();
    },

    onControlChange() {
        this.changed = true;

        this.refresh();
    },

    refresh() {
        var radioGroup = this.visibilityRadioGroup,
            visibility = this.visibility,
            disabled = visibility === 'disable';

        Ext.suspendLayouts();

        this.visibilityToggle.setChecked(!disabled);

        radioGroup.getRadioButtons().forEach(radio => {
            radio.setDisabled(disabled);
        });

        radioGroup.setValue(visibility);

        this.refreshAttributes();
        this.refreshConditions();

        this.applyBtn.setDisabled(!this.changed);

        Ext.resumeLayouts(true);
    },

    refreshAttributes() {
        Ext.suspendLayouts();

        var disabled = this.filterQuery.length === 4,
            filterText = Ext.Array.clean(this.filterText.getValue().split(/[^\w%#$]/)),
            filterRe = new RegExp(('(?=.*' + filterText.join(')(?=.*') + ')').replace(/\$/g, '\\$'), 'i'),
            attributes = SA.data.AttributesCache.get(this.projectView.getFilterableAttributes())
                .filter(attribute => attribute.name.match(filterRe))
                .map(({attribute}) => ({attribute, innerHtml: SA.BadgedAttributeLabel.getHtml({attribute})}));

        this.dataList.update(attributes);
        this.dataList.ifCls(disabled, 'sa-filters-attribute-list-disabled');

        Ext.resumeLayouts(true);
    },

    refreshConditions() {
        Ext.suspendLayouts();

        var me = this,
            conditionsList = this.conditionsList,
            booleanOperator = this.booleanOperator,
            query = this.filterQuery,
            oldItems = conditionsList.query('> *'),
            newItems = [];

        query.forEach(condition => {
            for (let index = 0, len = oldItems.length; index < len ; ++index) {
                if (oldItems[index].condition === condition) {
                    oldItems.splice(index, 1);

                    if (oldItems[index] && oldItems[index].is('divider-combo-button')) {
                        oldItems.splice(index, 1);
                    }
                    else {
                        pushDividerCombo();
                    }

                    return;
                }
            }

            newItems.push({
                xtype: 'filter-condition-row',
                condition
            });

            pushDividerCombo();

            function pushDividerCombo() {
                newItems.push({
                    xtype: 'divider-combo-button',
                    cls: 'sa-filters-condition-boolean-ct',
                    items: ['and', 'or'],
                    margin: '10 18 10 4',
                    saAnim: true,
                    value: booleanOperator,

                    selectHandler(op) {
                        me.booleanOperator = op;

                        me.onConditionsControlChange();
                    }
                });
            }
        });

        if (query.length === 4) {
            newItems.pop();
        }
        else {
            addOrKeepPlaceholder();
        }

        oldItems.forEach(item => {
            if (item.hideTime) {
                if (item.hideTime < new Date() - 5000) {
                    item.destroy();
                }
            }
            else {
                item.hide();
                item.hideTime = +new Date();
            }
        });

        conditionsList.add(newItems);

        conditionsList.query('divider-combo-button').forEach(btn => {
            btn.setValue(booleanOperator);
        });

        conditionsList.query('filter-condition-row').forEach(row => {
            row.on({
                'change:condition': this.onConditionRowChange,
                'remove:condition': this.onConditionRowRemoveRequest,
                scope: this
            });
        });

        Ext.resumeLayouts(true);

        function addOrKeepPlaceholder() {
            var currentRowCount = getCurrentRowCount(),
                newRowCount = query.length,
                cls = 'sa-filters-attribute-placeholder',
                index = oldItems.findIndex(item => !item.hideTime && item.hasCls(cls)),
                shouldAdd = index === -1 || newRowCount > currentRowCount;

            if (shouldAdd) {
                newItems.push(Ext.widget({
                    xtype: 'component',
                    cls,
                    html: 'Add a variable on the left<br>(Optional)',
                    maxWidth: 220,
                    saAnim: true
                }));
            }
            else {
                oldItems.splice(index, 1);
            }
        }

        function getCurrentRowCount() {
            return conditionsList.query('> *').filter(item => {
                return !item.hideTime && item.is('filter-condition-row');
            }).length;
        }
    },

    refreshHeight() {
        var viewportHeight = Ext.dom.Element.getViewportHeight();

        this.setHeight(Ext.Number.constrain(viewportHeight * 0.75, 425, 670));
    },

    save() {
        var query = this.filterQuery.slice(),
            filter = [this.booleanOperator].concat(query),
            projectView = this.projectView;

        projectView.setFilter(filter);
        projectView.setFilterVisibility(this.visibility);

        projectView.save();

        this.changed = false;

        this.applyBtn.setDisabled(true);
    },

    syncStateWithProjectView() {
        var projectView = this.projectView,
            filter = projectView.getFilter() || [];

        this.visibility = projectView.getFilterVisibility();

        this.booleanOperator = (filter[0] || 'and').toLowerCase();
        this.filterQuery = Ext.clone(filter.slice(1));

        this.changed = false;

        this.refresh();
    }
});